import { callApi } from 'loankeeper-common/api'

export const lookups = (action) =>
  callApi('ucc_lookups', {
    params: { action },
    body: {},
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const view = (params) =>
  callApi('ucc_view', {
    params,
    body: {},
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const providers = () => lookups('providers')
export const services = () => lookups('services')

export const debt = ({ ProviderID, ServiceID, AbonentCode }) =>
  callApi('ucc_oper', {
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    params: { action: 'debt' },
    body: { ProviderID, ServiceID, AbonentCode },
  })

export const pay = ({
  ClientID,
  HashSum_ClientID_,
  CashAccountID,
  HashSum_CashAccountID_,
  Amount,
  CommAmount,
  CashAuth,
  WHLSessionID,
  HashSum_WHLSessionID_,
  IDDocID,
  HashSum_IDDocID_,
  Payments,
}) =>
  callApi('ucc_oper', {
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    params: {
      action: 'pay',
    },
    body: {
      IDDocID,
      HashSum_IDDocID_,
      WHLSessionID,
      HashSum_WHLSessionID_,
      Amount,
      CommAmount,
      CashAccountID,
      HashSum_CashAccountID_,
      CashAuth,
      ClientID,
      HashSum_ClientID_,
      Payments,
    },
  })

export const comm = ({ ClientID, HashSum_ClientID_, ProviderID, ServiceID, Amount, CommAmount }) =>
  callApi('ucc_oper', {
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    params: {
      action: 'comm',
    },
    body: {
      ClientID,
      HashSum_ClientID_,
      Amount,
      ProviderID,
      ServiceID,
      CommAmount,
    },
  })

export const findchecks = ({ OperDate, ProviderID, AbonentDescrip, AbonentCode, SEC_UserID }) =>
  view({ action: 'findchecks', OperDate, ProviderID, AbonentDescrip, AbonentCode, SEC_UserID })

export const findpayments = ({
  OperDate,
  ProviderID,
  CardNumber,
  AbonentDescrip,
  AbonentCode,
  DocNo,
  OID,
  SEC_UserID,
}) =>
  view({
    action: 'findpayments',
    OperDate,
    ProviderID,
    CardNumber,
    AbonentDescrip,
    AbonentCode,
    DocNo,
    OID,
    SEC_UserID,
  })

export const lastpayments = ({ clientID, HashSum_ClientID_ }) =>
  view({
    action: 'lastpayments',
    ClientID: clientID,
    HashSum_ClientID_,
  })

export const disableEnablePayment = (PayRequestID, HashPayRequestID, StatusID) =>
  callApi('ucc_oper', {
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    params: {
      action: 'changestatus',
    },
    body: {
      PayRequestID,
      HashSum_PayRequestID_: HashPayRequestID,
      StatusID,
    },
  })

export const send = ({ PayRequestID, HashSum_PayRequestID_, OID, OHash }) =>
  callApi('ucc_oper', {
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    params: {
      action: 'send',
    },
    body: {
      PayRequestID,
      HashSum_PayRequestID_,
      OID,
      HashSum_OID_: OHash,
    },
  })
